import React from 'react';
import { Box, BoxProps, ThemingProps, useColorModeValue } from '@chakra-ui/react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

interface IconProps extends BoxProps {
  icon: FontAwesomeIconProps['icon'];
  fixedWidth?: FontAwesomeIconProps['fixedWidth'];
  size?: FontAwesomeIconProps['size'];
  colorScheme?: ThemingProps['colorScheme'];
  iconProps?: Omit<FontAwesomeIconProps, 'icon'>;
}

const Icon = (props: IconProps): React.ReactElement => {
  const { icon, fixedWidth, size, colorScheme = 'utility', iconProps, className, ...boxProps } = props;

  const isDefaultColor = colorScheme === 'utility';

  const iconColor = useColorModeValue(
    isDefaultColor ? 'utility.500' : `${colorScheme}.500`,
    isDefaultColor ? 'whiteAlpha.600' : `${colorScheme}.300`,
  );

  const combinedClassName = [isDefaultColor ? 'utility-icon' : '', className].filter(Boolean).join(' ');

  return (
    <Box
      as="span"
      color={iconColor}
      className={combinedClassName || undefined}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      lineHeight={'1.0'}
      {...boxProps}
    >
      <FontAwesomeIcon icon={icon} fixedWidth={fixedWidth} size={size} {...iconProps} />
    </Box>
  );
};

export { Icon };
